<template>
	<div v-if="$root.loading"></div>
	<div v-else class="document page-break">
		<h2 class="h">Акт приёма-передачи неисключительных прав <br>№ {{ $root.contract.number }} от <span v-if="$root.is_date_edit"><input type="text" name="" v-model="$root.act_date"><button @click="edit_date()">Изменить</button></span><span v-else @click="edit_date()">{{ $root.act_date }}</span></h2>
		<div v-if="$root.act_date.length < 13" style="margin-top: 20px; text-align: center;">
			<h2 style=" color: red;">Пожалуйста, добавьте дату</h2>
			<p>Пример: «01 Марта 2021г.»</p>
		</div>
		<div  v-else >
			<div style="margin-top: 60px;">
				<div>
					<p><b class="company_label">Продавец: {{ $root.licentiate.short_name }}</b>
					<br>ИНН {{ $root.licentiate.inn }} / КПП {{ $root.licentiate.kpp }}
					<br>{{ $root.licentiate.ur_adress }}
					<br>далее именуемый "Лицензиат"</p>
				</div>
				<div>
					<p>И <b class="company_label">{{ $root.sublicentiate.short_name }}</b>
					<br>ИНН {{ $root.sublicentiate.inn }} / КПП {{ $root.sublicentiate.kpp }}
					<br>{{ $root.sublicentiate.ur_adress }}
					<br>далее именуемый "Сублицензиат"</p>
				</div>
				<p>составили и подписали настоящий акт приёма - передачи о том, что "Лицензиат" передал, а "Сублицензиат" принял на условиях неисключительной лицензии права на использование программы для ЭВМ следующего наименования:</p>
			</div>
			<div class="spcf_table">
				<table class="table table-bordered" cellpadding="6">
					<tbody>
						<tr>
							<th>№ п.п.</th>
							<th>Наименование</th>
							<th>Единица измерения</th>
							<th>Количество лицензий</th>
							<th>Цена, руб.</th>
							<td><b>Сумма(без НДС)</b><br></td>
						</tr>
						<tr v-for="item, index in $root.products">
							<td>{{ index+1 }}</td>
							<td>{{ item.full_name }} сроком на {{ item.license_period }} месяцев.</td>
							<td>шт.</td>
							<td>{{ item.license_count }}</td>
							<td>{{ item.license_price }}</td>
							<td>{{ item.license_total_sum }}</td>
						</tr>
						<tr>
							<td></td>
							<th colspan="4">Итого:</th>
							<th>{{ $root.contract.total_sum  }}</th>
						</tr>
					</tbody>
				</table>
			</div>
			<div>
				<p>
				<br>Стоимость переданных прав на использование программы для ЭВМ составляет {{$root.contract.total_sum}} рублей ({{ $root.contract.text_sum }}). Без  НДС.
				<br>НДС не облагается в соответствии со ст. 149 гл.26.2  НК РФ
				</p>
			</div>
			<div class="rekv_table">
				<table class="table table-bordered">
					<tbody>
						<tr>
							<td>
								<p>
									Передал
									<br>{{ $root.licentiate.position }}
									<br><br>_________________/{{ $root.licentiate.director_short }}/
									<br>М.П.
								</p>
							</td>						
							<td>
								<p>
									Принял
									<br>{{ $root.sublicentiate.position }}
									<br><br>_________________/{{ $root.sublicentiate.director_short }}/
									<br>М.П.
								</p>
							</td>						
						</tr>
						<div class="sign_area">
							<div class="sign"></div>
						</div>
					</tbody>
				</table>
			</div>
		</div>
		<Save_instruction/>
	</div>
</template>

<script>
	import Save_instruction from '../../Save_instruction.vue'
	export default{
		data(){
			return{
				is_date_edit: false,

			}
		},
		components: {
			Save_instruction
		},
		methods:{
			edit_date(){
				if(this.$root.edit_date_access){
					this.$root.is_date_edit = !this.$root.is_date_edit;
					this.$root.set_act_date(this.$root.is_date_edit)
				}
			},

		},
		mounted(){
			if(!this.$root.document_number){
				this.$router.push('/documents/'+this.$route.params.id)
			}
			document.title = "Акт_"+this.$root.document_number;
			this.$root.get_act_date()
		}
	}
</script>

<style>
	.company_label{
		font-size: 16px;
	}
</style>
